<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage :page-titles="pageTitles" :form-open="form" :hide-button="true" @onClick="formOpen" />
      <section class="line row">
        <b-form class="mt-3 form-register" @submit.prevent="gerarRelatorio">
          <div class="row">
        <b-form-group label="Data inicial">
          <b-form-datepicker
            
            v-model="data_inicial"
            format="DD/MM/YYYY"
            valueType="YYYY-MM-DD"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            locale="pt-br"
          >
            <template v-slot:button-content>
              <b-icon icon="calendar" variant="primary"></b-icon>
            </template>
          </b-form-datepicker>
        </b-form-group>
        <b-form-group label="Data final">
          <b-form-datepicker
            
            v-model="data_final"
            format="DD/MM/YYYY"
            valueType="YYYY-MM-DD"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            locale="pt-br"
          >
            <template v-slot:button-content>
              <b-icon icon="calendar" variant="primary"></b-icon>
            </template>
          </b-form-datepicker>
        </b-form-group>
        
        
      </div>

          <b-btn type="submit" class="gerar" variant="primary">Gerar relatório</b-btn>
        </b-form>
        <div v-if="info">
          <h5>Status</h5>
          <p>
            Em dia: {{ info["Em dia"] }}
          </p>
          <p>
            Atrasado: {{ info["Atrasado"] }}
          </p>
        </div>
      </section>
      <div>
        <div class="text-right count-and-total">
          <div>
            <label>Total Geral: {{ report == null ? 0 : report.length }}</label>
          </div>
        </div>
        <Table :tables-fields="reportFields" :table-items="report" :hidden-buttons="true" />
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import unidadeMixin from '@/src/mixins/unidadeMixin'
import vendedorMixin from '@/src/mixins/vendedorMixin'
import reportRenovacaoEspecificaMixin from '@/src/mixins/reportRenovacaoEspecificaMixin'
import Table from '@/src/components/tables/table-register.vue'
import moment from 'moment'

export default {
  components: { Layout, HeaderPage, Table },
  mixins: [unidadeMixin, vendedorMixin, reportRenovacaoEspecificaMixin],
  data() {
    return {
      pageTitles: {
        title: 'Lista de Renovação',
        subtitle: '',
      },

      isLoading: false,

      unidade: null,
      unidades: [{ value: null, text: 'Selecione uma unidade' }],

      periodo: '',
      data_inicial: '',
      data_final: '',
      periodos: [
        { value: '', text: 'Selecione o periodo' },
        { value: '30', text: '30 dias' },
        { value: '30-60', text: '30 a 60 dias' },
        { value: '60-90', text: '60 a 90 dias' },
        { value: '90', text: '90 dias' },
      ],

      vendedor: null,
      vendedores: [{ value: null, text: 'Selecione o vendedor' }],

      report: null,
      info: null
    }
  },

  methods: {
    listUnidades() {
      this.loadUnidades().then(response => {
        response.map(unidade => {
          this.unidades.push({ value: unidade._id, text: `${unidade.cidade.trim()} - ${unidade.local.trim()} - ${unidade.unidade.trim()}` })
        })
      })
    },

    listVendedores() {
      this.loadVendedores().then(response => {
        response.map(vendedor => {
          this.vendedores.push({ value: vendedor._id, text: vendedor.nome.trim() })
        })
      })
    },

    gerarRelatorio() {
      if(this.data_inicial && this.data_final){
        this.isLoading = true
        this.specificRenewalByDate(this.data_inicial, this.data_final).then(response => {
          let {results, info} = response.data
          console.log(results)
          results.filter(item => {
            item.dataVencimento = moment(item.dataVencimento).format('DD/MM/YYYY')
            item.telefone = item.telefone && item.telefone.length > 0 ? item.telefone[0].numero : 'Sem número'
          })

          this.report = results
          this.info = info
          this.isLoading = false
        })
      }
    }
  }
}
</script>
<style src="../style.scss" lang="scss" scoped></style>
<style scoped>
.form-register {
  width: 50%;
  margin-top: 20px;
}

.line {
  margin-top: 20px;
}

.gerar {
  padding: 10px 20px !important;
  width: 30%;
}
.count-and-total {
  font-size: 17px;
}
</style>
